<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Temas de la Sala Técnica</span>
          </v-tooltip>
          <h3 class="headline mb-0">Temas</h3>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="nuevaTema">Agregar</v-btn>
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @click:append-outer="searchFilterTematic"
              @change="searchFilterTematic"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
               :loading="loading"
               :headers="headers"
               :items="tematics"
               rows-per-page-text="Filas por Pág"
               hide-actions
               :pagination.sync="pagination"
             >
               <template slot="items" slot-scope="props">

                 <td>{{ (props.item.tematic_id == null) ? props.item.name : props.item.tema}}</td>
                 <td>{{ (props.item.tematic_id != null) ? props.item.name : ''}}</td>

                 <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" >
                          <v-icon color="blue darken-2">description</v-icon>
                        </v-btn>
                        <span>Ver</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" >
                          <v-icon color="green">edit</v-icon>
                        </v-btn>
                        <span>Editar Tema</span>
                    </v-tooltip>

                   <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                        <span>Eliminar Tema</span>
                    </v-tooltip>

                 </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

            <div class="text-xs-center">
                <v-layout justify-center>
                  <v-flex xs8>
                    <v-card class="elevation-0">
                      <v-card-text>
                        <v-pagination
                          v-model="page"
                          :length="pages"
                        ></v-pagination>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
            </div>

          </v-card-text>
      </v-card>
    </v-flex>
     <!-- Inicio de dialogo -->
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Sala Técnica</v-card-title>

        <v-card-text>
          Clasificación de los temas a ser resueltos en la Sala Técnica.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Salir
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: 'specialties-view',

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        pages () {
            return this.pagination.total
        }
    },

    mounted() {
        this.initComponent(1)
    },

    watch: {
      page(v) {
        if(this.activePagination){
          this.initComponent(v)
        }
        this.activePagination = true
      }
    },

    data () {
        return {
            tematics: [],
            dialog: false,
            activePagination: false,
            loading: false,
            search: '',
            page: 0,
            pagination: {
                page: 1,
                totalItems: 0,
                rowsPerPage: 10,
                total: 0
            },
            headers: [
                { text: 'Tema', value: 'tema', sortable: false },
                { text: 'SUB-Tema', value: 'name', sortable: false },
                { text: 'ACCIONES', value: 'acciones', sortable: false }
            ],
        }
    },

    methods: {

        async initComponent (page,search=null) {
            this.loading = true
            const url = search == null ? `/api/tematics/admin/getTematics?page=${page}` : `/api/tematics/admin/getTematics?page=${page}&search=${search}`
            await axios.get(url)
                .then(resp => {
                  console.log(resp)
                    this.tematics = resp.data.data
                    this.page = resp.data.current_page
                    this.pagination = {
                        total: resp.data.last_page,
                        totalItems: resp.data.total,
                        rowsPerPage: resp.data.per_page,
                        page: 1
                    }
                })
                .catch(e => {
                    console.log(e.response,"error");
                })

            this.loading = false
        },

        nuevaTema() {

        },

        searchFilterTematic () {
            this.initComponent(this.page,this.search)
        }

    }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/atencion/tematics.vue